import {Injectable} from "@angular/core";
import {CreateFeatureDto} from "../dto/create-feature.dto";
import {Feature} from "../model/feature.model";
import {ValidationUtil} from "@qid/core";
import {RestService} from "../../../../services/rest.service";

@Injectable({
  providedIn: 'root'
})
export class FeatureService {

  private static readonly ApiEndpoint = 'master/feature/'

  constructor(private restService: RestService) {
  }

  create(dto: CreateFeatureDto) {
    ValidationUtil.validateName(dto.name, "Name")
    return this.restService.send({
      method: "POST",
      url: FeatureService.ApiEndpoint,
      body: dto
    })
  }

  async readAll() {
    return (await this.restService.send<Feature[]>({
      method: "GET",
      url: FeatureService.ApiEndpoint
    })).data
  }

  async update(featureDto: CreateFeatureDto) {
    return (await this.restService.send<Feature[]>({
      method: "PUT",
      url: FeatureService.ApiEndpoint + featureDto._id,
      body: featureDto
    })).data
  }

  async delete(featureId: string) {
    return (await this.restService.send({
      method: "DELETE",
      url: FeatureService.ApiEndpoint + featureId
    })).data
  }
}
